/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Teachprefix1Inputs */

const zh_landing_hero_teachprefix1 = /** @type {(inputs: Landing_Hero_Teachprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教 `)
};

const en_landing_hero_teachprefix1 = /** @type {(inputs: Landing_Hero_Teachprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teach `)
};

const es_landing_hero_teachprefix1 = /** @type {(inputs: Landing_Hero_Teachprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseña `)
};

/**
* | output |
* | --- |
* | "Teach" |
*
* @param {Landing_Hero_Teachprefix1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_hero_teachprefix1 = /** @type {((inputs?: Landing_Hero_Teachprefix1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Teachprefix1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_hero_teachprefix1(inputs)
	if (locale === "en") return en_landing_hero_teachprefix1(inputs)
	return es_landing_hero_teachprefix1(inputs)
});
export { landing_hero_teachprefix1 as "landing_hero_teachPrefix" }